/*jshint esversion: 6 */

import get from 'lodash/get';

//-------------------------------------------------------------------
// Quiz result paths
//-------------------------------------------------------------------

/* Get the path to the logged in users result */
export const getQuizDataPath = (auth) => {
    return 'quiz/' + get(auth, 'uid');
}

/* Get the path to the logged in users current quiz result */
export const getCurrentQuizPath = (auth, quiz) => {
    return `${getQuizDataPath(auth)}/${get(quiz, 'post.id')}/`;
}

export const getPointsPath = (auth, quiz) => {
    return `${getCurrentQuizPath(auth, quiz)}points`;
}

export const getAnswerPath = (auth, quiz, question) => {
    return `${getCurrentQuizPath(auth, quiz)}/answers/${question.id}`;
}

export const getBadgesPath = (auth, badge) => {
    return `${getQuizDataPath(auth)}/badges/${badge}`;
};

export const getAllBadgesPath = (auth) => {
    return `${getQuizDataPath(auth)}/badges`;
};

export const getNewBadgesPath = (auth) => {
    return `${getQuizDataPath(auth)}/new_badges`;
};

export const getAllQuizResultPath = (auth) => {
    return `${getQuizDataPath(auth)}/results`;
};

//-------------------------------------------------------------------
// User profile paths
//----------------------------`---------------------------------------

export const userProfilePath = auth => {
    return `users/${get(auth, 'uid')}/`;
}

export const userScorePath = auth => {
    return `users/${get(auth, 'uid')}/score`;
}

export const getPathForTag = (tag, auth) => {
    return `${userProfilePath(auth)}tags/${tag}`;
}

//-------------------------------------------------------------------
// General paths
//-------------------------------------------------------------------

export const topScore = () => {
    return `${getGeneralPath()}/topScore`;
}

export const getPathForCollectedPoints = quiz => {
    return `${getGeneralPath()}/collectedPoints`;
}

/* Get the path for max points for the current quiz */
export const getPathForQuizMaxPoints = (quiz) => {
    return getGeneralPathForProp('maxPoints', quiz);
}

/* Get the path for best finishing time for the current quiz */
export const getPathForQuizFinishingTime = (quiz) => {
    return getGeneralPathForProp('finishingTime', quiz);
}

export const getGeneralPathForProp = (prop, quiz) => {
    return `${getGeneralPath()}quizzes/${quiz.post.id}/${prop}`;
}

/* Get the path for the general data */
export const getGeneralPath = () => {
    return `general/`;
}
